/**************************************************
 * Nombre:       Agendar_RI
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import BotonGradiente from "../../../Componentes/BotonGradiente";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";
import BotonGradienteCita from "../../../Componentes/BotonGradienteCita";

const Agendar_RI = ({item, cupos}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: '#000'}}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 6}}

            >

                <Grid container size={{xs: 12, sm: 12, md: 10}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>


                        <Grid container size={{xs: 12, sm: 12, md: 5}}>
                            <Typography sx={{
                                color: '#fff',
                                fontSize: 24,
                                fontWeight: 800,
                                lineHeight: 1.2,
                                textAlign: sCell ? 'center' : 'left'
                            }}>Agenda
                                Reunion con nosotros
                                asi te contamos como lo hacemos</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: sCell ? 'center' : 'flex-end', mt: sCell ? 4 : 0}}>
                            <BotonGradienteCita cupos={cupos} idLanding={item.id} />
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Agendar_RI